import React from 'react';
import { initializeIcons } from '@uifabric/icons';
import { withTranslation, WithTranslation } from 'react-i18next';
import { ShortCutPaneComponent } from './component';
import history from '../../../history';
import { messageService } from '../../../services/messageService';
import { ContractListPaneFilter, ContractShortCutPaneItem } from '../../../types/contract';
import { getContractingUnit, getProject } from '../../../shared/util';

initializeIcons();

interface Props extends WithTranslation {
  shortCutPaneFilters: ContractShortCutPaneItem[];
  handelShortCutPaneFilter: (selectedItem: ContractShortCutPaneItem) => void;
  filter: ContractListPaneFilter;
  projectId: string | null;
  toggleOverlay: boolean;
  resetLayout: boolean
  isExpand: boolean;
}

interface State {
  divClass: string;
  selectedCodeType: number;
  currentActiveSection: string | null;
  isCollapse: boolean
}

class ShortCutPane extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      divClass: 'filter-panel-left',
      selectedCodeType: -1,
      currentActiveSection: null,
      isCollapse: false,
    };
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (this.props.toggleOverlay !== prevProps.toggleOverlay) {
      if (this.props.toggleOverlay) {
        this.setState({ divClass: 'filter-panel-left panel-move' });
      } else {
        this.setState({ divClass: 'filter-panel-left' });
      }
    }
    // if(this.props.resetLayout !==prevProps.resetLayout){
    //   if(this.props.resetLayout){
    //     this.setState({ divClass: 'filter-panel-left' });
    //   }
    // }
  }

  componentDidMount() {
    if (this.state.divClass === 'filter-panel-left') {
      if (window.innerWidth > 1300) {
        messageService.sendMessage({ shortCutPaneExpanded: true });
      }
    } else {
      messageService.sendMessage({ shortCutPaneExpanded: false });
    }
  }

  private handelShortCutPaneFilter = (selectedItem: ContractShortCutPaneItem) => {
    this.setState({
      currentActiveSection: selectedItem.id,
    });
    let filter: ContractListPaneFilter = new ContractListPaneFilter();

    history.push({
      pathname: `/CU/${getContractingUnit()}/project/${getProject()}/contract`,
      state: { contractFilter: filter },
    });
    messageService.sendMessage({
      contractFilter: filter,
    });
    this.props.handelShortCutPaneFilter(selectedItem);
  };

  private resetFilter = () => {
    let filterItem: ContractShortCutPaneItem = {
      key: null,
      id: null,
      type: null,
      name: 'All',
      value: null,
    };
    this.setState({
      currentActiveSection: null,
    });

    this.props.handelShortCutPaneFilter(filterItem);
  };

  public render(): JSX.Element {
    return (
      <ShortCutPaneComponent
        currentActiveSection={this.state.currentActiveSection}
        toggleOverlay={this._toggleOverlay}
        shortCutPaneFilters={this.props.shortCutPaneFilters}
        toggleOverlayFwd={this._toggleOverlayFwd}
        handelShortCutPaneFilter={(selectedItem: ContractShortCutPaneItem) =>
          this.handelShortCutPaneFilter(selectedItem)
        }
        resetFilter={() => this.resetFilter()}
        divClass={this.state.divClass}
      />
    );
  }

  private _toggleOverlay = (): void => {
    this.setState({ divClass: 'filter-panel-left panel-move', isCollapse: true });
    messageService.sendMessage({ shortCutPaneExpanded: false });
  };
  private _toggleOverlayFwd = (): void => {
    this.setState({ divClass: 'filter-panel-left', isCollapse: false });
    messageService.sendMessage({ shortCutPaneExpanded: true });
  };
}

export default withTranslation()(ShortCutPane);
